module.exports = __webpack_public_path__ + "media/images/front/sp/atopy-control-check/img02-b26df00b192479112a820130db81b019.png";